module.exports = __webpack_public_path__ + "img/tour-head.16bc2b8b.png";